<template>
  <FormContainer>
    <template #title>Coordonnées de l'apprenti(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_47"
          v-model="voieModel"
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VOIE"
          :required="meta.apprenti?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.adresse?.voie?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_47"
          v-model="complementAdresseModel"
          label="Complément d'adresse"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_COMPLEMENT"
          :required="meta.apprenti?.adresse?.complement?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.adresse?.complement?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_48"
          v-model="codePostalModel"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_CP"
          :required="meta.apprenti?.adresse?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.adresse?.codePostal?.$messageErreurDirty!"
          :maxlength="5"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_49"
          v-model="communeModel"
          label="Commune"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VILLE"
          :required="meta.apprenti?.adresse?.commune?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.adresse?.commune?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_50"
          v-model="telephoneModel"
          label="Téléphone"
          :required="meta.apprenti?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.telephone?.$messageErreurDirty!"
          class="col-6 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :maxlength="10"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_51"
          v-model="emailModel"
          label="Email"
          :required="meta.apprenti?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.email?.$messageErreurDirty!"
          hint="64 caractères maximum"
          class="col-10 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          :maxlength="64"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import {
    FormContainer,
    PLACEHOLDER_ADR_VOIE,
    PLACEHOLDER_ADR_COMPLEMENT,
    PLACEHOLDER_ADR_CP,
    PLACEHOLDER_ADR_VILLE,
    PLACEHOLDER_TEL,
    PLACEHOLDER_EMAIL,
    LABEL_NUMERO_VOIE,
  } from '@/features/interface/demande/shared'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const voieModel = setupFieldWithKey<string>('apprenti.adresse.voie', true)
  const complementAdresseModel = setupFieldWithKey<string>('apprenti.adresse.complement', true)
  const codePostalModel = setupFieldWithKey<string>('apprenti.adresse.codePostal', true)
  const communeModel = setupFieldWithKey<string>('apprenti.adresse.commune', true)
  const telephoneModel = setupFieldWithKey<string>('apprenti.telephone', true)
  const emailModel = setupFieldWithKey<string>('apprenti.email', true)
</script>
